module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Frying-pan-4f74e08f1f9dda92436f0e555b78222c.svg";